var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArc = function SvgArc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1025 75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.326.73H1024.33v73.306C605.909 4.92 381.595 4.612.326 74.036z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#909090",
    strokeOpacity: 0.35,
    d: "M.326 72.91C386.91 5.345 610.74 5.697 1022 72.91"
  })));
};
export default SvgArc;